'use strict'

import ApiClient from './ApiClient'

export default class NisfaIntegrationRepository {
  /**
   * SFA連携設定の取得
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/nisfa-integration`)
  }

  /**
   * SFA連携設定の更新
   * @param {Object} params 登録情報
   * @returns {*}
   */
  put (params) {
    return ApiClient().put(`/nisfa-integration`, params)
  }

  /**
   * NISFA連携先への接続テスト
   * @param {Object} data TODO
   * @returns {*}
   */
  test (data) {
    return ApiClient().post(`/nisfa-integration/test`, data)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/NisfaIntegrationRepository.js